import React from 'react';
import Styles from './styles.module.scss';

const buildPolygonPoints = (width, height, cut, corners, strokeInset = 0) => {
    const tl = corners.topLeft ? cut : 0;
    const tr = corners.topRight ? cut : 0;
    const br = corners.bottomRight ? cut : 0;
    const bl = corners.bottomLeft ? cut : 0;

    const x0 = strokeInset;
    const y0 = strokeInset;
    const x1 = width - strokeInset;
    const y1 = height - strokeInset;

    const points = [
        `${x0 + tl},${y0}`,      // top edge start
        `${x1 - tr},${y0}`,      // top edge end before TR cut
        `${x1},${y0 + tr}`,      // right edge start after TR cut
        `${x1},${y1 - br}`,      // right edge end before BR cut
        `${x1 - br},${y1}`,      // bottom edge start after BR cut
        `${x0 + bl},${y1}`,      // bottom edge end before BL cut
        `${x0},${y1 - bl}`,      // left edge start after BL cut
        `${x0},${y0 + tl}`,      // left edge end before TL cut
    ];

    return points.join(' ');
};

const CustomBorder = ({
                          children,
                          className = '',
                          borderColor = '#2ee9ff',
                          borderWidth = 0.5,
                          cutSize = 30,
                          corners = { topRight: true, bottomLeft: true },
                          fill = false, // 👈 по умолчанию как на скрине
                          withHover = false
                      }) => {
    const W = 1000;
    const H = 260;

    const scale = 4;
    const cut = cutSize * scale;
    const strokeWidth = borderWidth * scale;
    const strokeInset = strokeWidth / 2;

    const points = buildPolygonPoints(W, H, cut, {
        topLeft: !!corners.topLeft,
        topRight: !!corners.topRight,
        bottomRight: !!corners.bottomRight,
        bottomLeft: !!corners.bottomLeft,
    }, strokeInset);

    return (
        <div className={`${Styles.customBorderWrap} ${className} ${withHover ? Styles.customBorderWrapWH : null}`}>
            <svg
                aria-hidden="true"
                viewBox={`0 0 ${W} ${H}`}
                preserveAspectRatio="none"
                className={Styles.frame}
            >
                <polygon
                    points={points}
                    fill={fill ? fill : 'none'}
                    stroke={borderColor}
                    strokeWidth={strokeWidth}
                    vectorEffect="non-scaling-stroke"
                    shapeRendering="geometricPrecision"
                />
            </svg>

            <div className={Styles.content}>
                {children}
            </div>
        </div>
    );
};

export default CustomBorder;
